<template>
  <div class="mine">
    <!-- 我的banner  开始 -->
    <div class="mine_topimg">
      <div class="mine_banner">
        <div class="banner-left">
          <div class="mine_touxiang">
            <img src="/static/mine_morentouxiang.png" class="mine_weixinimg" />
          </div>
          <div class="mine_weixinmesg">
            <div class="mine_weixinnamebox">
              <div class="mine_weixinname" v-if="userInfo.username">{{ userInfo.username }}</div>
              <img src="/static/baiyinka.png" v-if="usertype == '2'" @click="tovipcard" class="mine_weixinnamelabel"
                alt="" />
            </div>
            <div class="mine_weixinphone" @click="userInfo.mobile ? '' : tochangephonenum()">{{ userInfo.mobile ?
              userInfo.mobile : "去绑定手机号" }}</div>
          </div>
        </div>
        <!-- <div class="botton-right">
          <div class="change-phone" @click="tochangephonenum()">修改手机号</div>
        </div> -->
        <div class="return-login" @click="signOut()">清除缓存</div>
      </div>
      <img src="/static/mine_jifenchongzhi.png" class="minejifenchong" @click="toaccount()">
      <div class="minejifenbox">
        <div class="jifendetail" @click="toaccount()">
          <div>{{ userInfo.account ? userInfo.account.amount : 0 }}</div>
          <div>我的积分</div>
        </div>
        <div class="jifendetail" @click="tocouponsList()">
          <div>{{ userInfo.package_account }}</div>
          <div>我的卡券</div>
        </div>
      </div>
    </div>
    <!-- 我的banner  结束 -->
    <!--  我的订单 -->
    <div class="mine-orderbox">
      <div class="mine-ordertop" @click="toOrder('0')">
        <div class="mine-ordertitle">我的订单</div>
        <div class="mine-morebox">
          <div>全部订单</div>
          <img src="/static/mine_gengduo.png" class="mine-moreicon">
        </div>
      </div>
      <div class="mine-orderstatuslist">
        <div class="mine-orderstatusbox" v-for="(item, index) in orderStatus" @click="toOrder(item.status)">
          <img :src="item.icon" class="mine-ordericon">
          <div>{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 更多服务 开始 -->
    <div class="mine-service-list">
      <div class="mine-service-box" @click="tomingxi()">
        <img class="mine-service-img" src="/static/mine_jifenmingxi.png" />
        <div>积分明细</div>
      </div>
      <div class="mine-service-box" @click="tocoupinsList()">
        <img class="mine-service-img" src="/static/mine_kaquanliebiao.png" />
        <div>卡券列表</div>
      </div>
      <div class="mine-service-box" @click="toCarList()">
        <img class="mine-service-img" src="/static/mine_wodeaiche.png" />
        <div>我的爱车</div>
      </div>
      <div class="mine-service-box" @click="toAnnualReview()">
        <img class="mine-service-img" src="/static/mine_nianshendingdan.png" />
        <div>年审订单</div>
      </div>
      <div class="mine-service-box" @click="tobankList()">
        <img class="mine-service-img" src="/static/mine_kaguanli.png" />
        <div>卡管理</div>
      </div>
    </div>
    <!-- 更多服务 结束 -->
    <!--  <div class="mine_order" @click="toOrder()">-->
    <!--      <div class="order_left">-->
    <!--        <img class="mine_order_icon" src="/static/newicon/order.png" />-->
    <!--        <div class="mine_order_text">我的订单</div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="mine_guize">
      <div class="order_left">
        <img class="mine_order_icon" src="/static/guize.png" />
        <div class="mine_order_text">积分规则</div>
      </div>
      <img class="mine_order_todetail" src="/static/xiangyou.png" />
    </div> -->
    <!-- <div class="mine_guize" @click="tomingxi()">
      <div class="order_left">
        <img class="mine_order_icon" src="/static/newicon/jifenmingxi.png" />
        <div class="mine_order_text">积分明细</div>
      </div>
    </div>
    <div class="mine_guize" @click="tocoupinsList()">
      <div class="order_left">
        <img class="mine_order_icon" src="/static/newicon/kaquanliebiao.png" />
        <div class="mine_order_text">卡券列表</div>
      </div>
    </div> -->
    <!-- <div class="mine_guize" @click="toAddressList()">
        <div class="order_left">
          <img class="mine_order_icon" src="/static/address.png" />
          <div class="mine_order_text">收货地址</div>
        </div>
      </div> -->
    <!--    <div class="phonenum">客服电话：<a :href="'tel:' + phoneNumber">{{phoneNumber}}</a></div>-->
    <div class="minenone"></div>
    <taber></taber>
  </div>
</template>

<script>
import taber from '@/components/taber/taber'
import httper from '../../api/http';
import {
  Dialog
} from 'vant';
export default {
  components: {
    taber
  },
  data() {
    return {
      phoneNumber: "", //客服热线
      userInfo: {}, //用户信息
      phonenum: "",
      availableUser: false, //是否为可用用户
      // amount:0//积分
      usertype: "",
      showccardtype: false,
      orderStatus: [{
        text: "待支付",
        icon: require("../../../static/order_daizhifu.png"),
        status: "1"
      }, {
        text: "处理中",
        icon: require("../../../static/order_chulizhong.png"),
        status: "2"
      }, {
        text: "已完成",
        icon: require("../../../static/order_yiwancheng.png"),
        status: "3"
      }, {
        text: "售后",
        icon: require("../../../static/order_shouhou.png"),
        status: "4"
      }]
    }
  },
  created() {
    this.request('getUserInfo')
    this.phoneNumber = sessionStorage.getItem("phoneNumber")
    if (localStorage.getItem("usertype")) {
      this.usertype = localStorage.getItem("usertype")
    }
  },
  mounted() {

  },
  methods: {
    toOrder(order_status) {
      this.$router.push({
        path: "/orderList",
        query: {
          order_status: order_status
        }
      })
    },
    tomingxi() {
      this.$router.push({
        path: "/jifenmingxi"
      })
    },
    toaccount() {
      this.$router.push({
        path: "/account"
      })
    },
    totixian() {
      this.$router.push({
        path: "/tixian"
      })
    },
    //车主卡
    tovipcard() {
      let that = this
      if (!(Object.keys(that.userInfo.ccard).length === 0)) {
        if (that.userInfo.ccard.ccard_id) {
          let card_id = this.userInfo.ccard.id
          let carddetail = {}
          this.$router.push({
            path: "/vipcard",
            query: {
              ccard_id: card_id
            }
          })
        } else {
          this.$router.push({
            path: "/vipcard"
          })
        }
      }


    },
    //可用用户
    isavailableUser() {
      let that = this
      var userId = [42, 45, 46, 49, 50, 168, 167]
      for (var i = 0; i < userId.length; i++) {
        if (userId[i] == that.userInfo.id) {
          that.availableUser = true
        }
      }
      console.log("that.availableUser", that.availableUser)
    },
    //跳转卡券列表
    tocouponsList() {
      this.$router.push({
        path: '/couponsList'
      })
    },
    tocoupinsList() {
      this.$router.push({
        path: "/couponsList"
      })
    },
    //车牌列表
    toCarList() {
      this.$router.push({
        path: "/CarLicenseList",

      })
    },
    //年审订单
    toAnnualReview() {
      this.$router.push({
        path: "/annualReviewList",

      })
    },
    //银行卡列表
    tobankList() {
      this.$router.push({
        path: "/banklist",
      })
    },
    //京东充值
    tojingdongRecharge() {
      this.$router.push({
        path: "/jingdongRecharge",
      })
    },
    //账户充值
    toIntegralRecharge() {
      this.$router.push({
        path: "/IntegralRecharge",
      })
    },
    //地址列表
    toAddressList() {
      this.$router.push({
        path: "/projectAddressList"
      })
    },
    //绑定手机号
    tochangephonenum() {
      this.$router.push({
        path: "/changePhoneNum",
        query: {
          phone: this.userInfo.mobile
        }
      })
    },
    // changeTip(){
    //   this.$toast({
    //     message: "手机号只能绑定一次，无法改绑"
    //   })
    // },
    //绑定手机号
    tochangephonenum1() {
      if (this.userInfo.mobile) {
        this.$router.push({
          path: "/changePhoneNum",
          query: {
            phone: this.userInfo.mobile
          }
        })
      } else {
        this.$router.push({
          path: "/changePhoneNum",
        })
        //   Dialog.confirm({
        //       title: '提示',
        //       message: '请先绑定手机',
        //     })
        //     .then(() => {
        //       that.$router.push({
        //         path: "/changePhoneNum"
        //       })
        //     })
        //     .catch(() => {
        //       return false;
        //     });
      }
    },
    signOut() {
      Dialog.confirm({
        title: '提示',
        message: '确定清除缓存？',
      })
        .then(() => {
          sessionStorage.removeItem("source")
          localStorage.removeItem('access_token');
          localStorage.removeItem('userinfo');
          sessionStorage.removeItem("city")
          sessionStorage.removeItem("latitude")
          sessionStorage.removeItem("longitude")
          localStorage.removeItem("cardNo")
          localStorage.removeItem('openId');
          localStorage.removeItem('withdrawType')
          this.$router.push({
            path: "/"
          })
          // wx.closeWindow()
        })
        .catch(() => {
          return false;
        });
    },
    // 调用接口
    request(type = '', requestData = {}) {
      let that = this
      switch (type) {
        // 获取用户信息
        case 'getUserInfo':
          httper.get('wechat/user/info', requestData, res => {
            if (res.code == 0) {
              that.userInfo = res.data
              this.showccardtype = !(Object.keys(that.userInfo.ccard).length === 0);
              this.isavailableUser()
            }
          }, true)
          break
        case 'getphoneNumber':
          httper.get('index/tel-phone', requestData, res => {
            if (res.code == 0) {
              that.phoneNumber = res.data
            }
          })
          break
      }
    },
  }
}
</script>

<style>
body {
  margin: 0;
  background-color: #F6F8FA !important;
}

.mine {
  width: 100%;
}

.mine_top {
  width: 90.3%;
  height: 100px;
  /* background: -webkit-linear-gradient(bottom, hsl(202, 37%, 90%), hsl(226, 100%, 84%), #3b6bfb) no-repeat;
 */
  background-color: #fcddd8;
  display: flex;
  padding: 20px;
  align-items: center;
  color: #000000;
}

.mine_touxiang {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  margin-right: 14px;
}

.touxiang {
  width: 100%;
  height: 100%;
  border-radius: 25px;
}

.mine_weixinimg {
  width: 100%;
  height: 100%;
  border-radius: 25px;
}

.mine_weixinmesg {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* color: #fff; */
  font-size: 17px;
  margin-right: 60px;
}

.mine_weixinname {
  font-size: 19px;
  font-weight: bold;
}

.mine_weixinnamebox {
  display: flex;
  align-items: center;
}

.mine_weixinnamelabel {
  width: 64px;
  height: 26px;
  margin-left: 11px;
}

.mine_weixinphone {
  font-size: 12px;
}

.mine_top_right {
  /* color: #fff; */
}

.mine_topr_text {}

.mine_center_tab {
  height: 75px;
  position: absolute;
  top: 105px;
  background-color: #fff;
  width: 91%;
  margin-left: 17px;
  border-radius: 10px;
  box-shadow: 3px 3px 3px #c2c0c0;
  display: flex;
  align-items: center;

}

.mine_jifen_top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  margin: 10px;
  height: 25px;
  border-right: 1px solid #e3e3e3;
}

.mine_jifen {
  width: 40px;
  height: 40px;
  margin-right: 15px;
}

.jifen_emg {
  font-size: 16px;
}

.mine_kaquan_top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  margin: 10px;
  height: 25px;
  /*    border-right: 1px solid #e3e3e3; */
}

.mine_kaquan {
  width: 40px;
  height: 40px;
  margin-right: 15px;

}

.kaquan_emg {
  font-size: 16px;

}

.mine_order {
  display: flex;
  margin-top: 20px;
  /* margin-top: 60px; */
  padding: 10px 20px;

  border-bottom: 1px solid #f0f0f0;

  align-items: center;
  justify-content: space-between;
}

.order_left {
  display: flex;
  align-items: center;
}

.mine_order_icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.mine_order_text {
  font-size: 15px;

  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.mine_order_todetail {
  width: 20px;
  height: 20px;

}

.mine_guize {
  display: flex;
  padding: 10px 20px;
  border-bottom: 1px solid #f0f0f0;

  align-items: center;
  justify-content: space-between;
}

.mine_topimg {
  width: 100%;
  background-size: cover;
  background: linear-gradient(0deg, #F6F8FA 0%, #FEEFDD 48%);
  border-radius: 0 0 19px 19px;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}

.mine_banner {
  width: 100%;
  height: 100px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 积分/卡券 开始 */
.mine_center {
  width: 100%;
  height: 120px;
  /* position: absolute;
    top: 170px; */
  position: relative;
  top: 0;
  margin-top: -15%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.mine_center_jifen {
  width: 172px;
  height: 115px;

  background: rgba(255, 255, 255, 1);
  box-shadow: 0 3px 4px 1px rgba(187, 187, 187, 0.3);
  border-radius: 7px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.mine_jifen_img {
  width: 46px;
  /* height: 46px; */
  margin-right: 5px;

}

.mine_jifen_text {}

.mine_jifen_title {
  font-size: 15px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.mine_jifen_num {
  font-size: 19px;
  font-weight: 400;
  color: rgba(2, 156, 255, 1);
  line-height: 23px;

}

.mine_kaquan_num {
  font-size: 19px;
  font-weight: 400;
  color: rgba(160, 150, 247, 1);
  line-height: 23px;
}

.mine_center_kaquan {}

.phonenum {
  text-align: center;
  color: #808080;
  margin-top: 10px;
}

a {
  text-decoration: none;
  /* color: #808080; */
  font-size: 14px;
}

.return-login {
  width: 58px;
  height: 23px;
  border: 1px solid #000000;
  border-radius: 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-left {
  display: flex;
  align-items: center;
}

.mine-moretitle {
  margin-left: 20px;
  font-size: 15px;
  font-weight: bold;
}

.mine-service-list {
  width: calc(100% - 40px);
  margin: 20px;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background-color: #FFFFFF;
  border-radius: 12px;
}

.mine-service-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 10px;
  font-size: 14px;
  color: #333333;
}

.mine-service-img {
  width: 37px;
  height: 37px;
  margin-bottom: 15px;
}

/* 积分/卡券 结束 */
.botton-right {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.change-phone {
  width: 70px;
  height: 23px;
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vipcardlabel {
  width: 100%;
  height: 46px;
  background: linear-gradient(90deg, #1F1F1F 49%, #212228 99%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  box-sizing: border-box;
}

.vipcardlabelleft {
  display: flex;
  align-items: center;

}

.vipcardlabelname {
  font-size: 20px;
  font-style: italic;
  color: #FFFFFF;
  font-weight: bold;
  margin-right: 5px;
}

.vipcardlabelname1 {
  /*width: 64px;*/
  height: 22px;
  background: #FFFFFF;
  color: #000000;
  border-radius: 4px;
  font-size: 18px;
  /* font-style: italic; */
  font-weight: bold;
  transform: skew(-15deg);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  box-sizing: border-box;
}

.vipcardlabelname2 {
  font-size: 12px;
  font-style: italic;
  color: #FFFFFF;
}

.vipcardlabelbotton {
  width: 77px;
  height: 27px;
  background: #FFFFFF;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #202023;
}

.minejifenchong {
  width: 100%;
  height: 52px;
  border-radius: 12px 12px 0 0;
}

.minejifenbox {
  width: 100%;
  height: 65px;
  border-radius: 0 0 12px 12px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: -6px;
}

.jifendetail {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
}

.mine-orderbox {
  width: calc(100% - 40px);
  margin: 20px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 12px;
  background: #FFFFFF;
}

.mine-ordertop {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mine-ordertitle {
  font-size: 15px;
  color: #333333;
}

.mine-morebox {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #BBBBBB;
}

.mine-moreicon {
  width: 11px;
  height: 11px;
  margin-left: 10px;
}

.mine-orderstatuslist {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.mine-orderstatusbox {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
  color: #333333;
}

.mine-ordericon {
  width: 36px;
  height: 34px;
  margin-bottom: 13px;
}

.minenone {
  width: 100%;
  height: 40px;
}</style>



// WEBPACK FOOTER //
// src/pages/mine/mine.vue